<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-17 16:53:09
 * @LastEditTime: 2019-08-26 18:03:51
 * @LastEditors: Please set LastEditors
 -->
<template>
    <div class="container">
       <div>
            <el-button type="primary" @click="add()" style="margin-bottom:10px;">添加经销商</el-button>
       </div>
        <el-form ref="form" :model="form" label-width="100px" :inline="true" class="mt20">
              <el-form-item label="添加时间" style="text-align: center">
                <el-col :span="11">
                    <el-date-picker type="date" placeholder="开始时间" v-model="form.start"
                                    style="width: 100%;"></el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                    <el-date-picker type="date" placeholder="结束时间" v-model="form.end"
                                    style="width: 100%;"></el-date-picker>
                </el-col>
            </el-form-item>
            <el-form-item label="经销商编号:">
                <el-input v-model="form.dealer_sn" clearable></el-input>
            </el-form-item>
            <el-form-item label="经销商名称:">
                <el-input v-model="form.dealer_name" clearable></el-input>
            </el-form-item>
             <el-form-item label="经销商状态:">
                        <el-select v-model="form.status" placeholder="经销商状态" clearable>
                               <el-option value="">全部</el-option>
                            <el-option value="1">正常</el-option>
                            <el-option value="2">禁用</el-option>  
                            <el-option value="3">删除</el-option>
                        </el-select>
                    </el-form-item>
            <el-form-item label="经销商类型:">
                        <el-select v-model="form.level_id" placeholder="经销商类型" clearable>
                            <el-option v-for=" i in storeList" :key="i.id" :label="i.lname"
                                       :value="i.id"></el-option>
                        </el-select>
                    </el-form-item>
                
           <el-form-item label="区域:" >
                        <el-select  v-model="form.region_country" placeholder="请选择一级区域" clearable style="margin-right:10px" @change='getprovinces()'>
                            <el-option v-for=" i in countrys" :key="i.id" :label="i.region_name"
                                       :value="i.region_id"></el-option>
                        </el-select>
                        <el-select  v-model="form.region_province" placeholder="请选择二级区域" clearable style="margin-right:10px" @change='getcity()'>
                            <el-option v-for=" i in provinces" :key="i.id" :label="i.region_name"
                                       :value="i.region_id"></el-option>
                        </el-select>
                        <el-select v-model="form.region_city" placeholder="请选择三级区域" clearable style="margin-right:10px"   @change='getArea()' >
                            <el-option v-for=" i in citys" :key="i.id" :label="i.region_name"
                                       :value="i.region_id"></el-option>
                        </el-select>
                        <el-select  v-model="form.region_area" placeholder="请选择四级区域" clearable style="margin-right:10px" @change='$forceUpdate()'>
                            <el-option v-for=" i in areas" :key="i.id" :label="i.region_name"
                                       :value="i.region_id"></el-option>
                        </el-select>
                </el-form-item>
                     <el-form-item>
                <el-button type="primary" @click="onSearch()">搜索</el-button>
            <!-- <el-button>导出</el-button>-->
            </el-form-item>
           
        </el-form>
        <!--表格-->
        <el-table
                ref="multipleTable"
                :data="tableData"
                border
                stripe
                v-loading='loading'
                height="350"
                style="width: 100%">
            <el-table-column
                    label="经销商编号"
                    width="140"
                    prop='dealer_sn'
                    fixed
            >
            </el-table-column>
            <el-table-column
                    prop="dealer_name"
                    label="经销商名称"
                  
                    fixed>
            </el-table-column>
            <el-table-column
                    prop="lname"
                    label="经销商类型"
                    width="100"
                    show-overflow-tooltip>
            </el-table-column>
               <el-table-column
                    prop="address"
                    label="经销商地址"
                    
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="person"
                    label="负责人"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="mobile"
                    label="手机号码"
                    show-overflow-tooltip>
              
            </el-table-column>
            <el-table-column
                    prop="product_name"
                    label="状态"
                    show-overflow-tooltip
                    width="60">
                    <template slot-scope="scope">
                        <span v-if='scope.row.status==1'>正常</span>
                        <span v-if='scope.row.status==2'>禁用</span>
                    </template>
            </el-table-column>
            <el-table-column
                    prop=""
                    label="下级门店"
                    show-overflow-tooltip
                    width="80">
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="detail(scope.row)">查看</el-button>
                </template>
            </el-table-column>
            <el-table-column
                    prop=""
                    label="操作"
                    show-overflow-tooltip>
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="detail(scope.row)">详情</el-button>
                    <el-button type="text" size="small" @click="edit(scope.row)">编辑</el-button>
                    <el-button type="text" size="small" @click="disables(scope.row,2)" v-if='scope.row.status!=2'>禁用</el-button>
                    <el-button type="text" size="small" @click="disables(scope.row,1)" v-if='scope.row.status==2'>启用</el-button>
                    <el-button type="text" size="small" @click="disables(scope.row,3)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!--分页-->
        <el-pagination
                style="margin: 20px 0"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageNo"
                :page-sizes="[20, 50, 100, 200]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalSize">
        </el-pagination>
        <!--发货-->
        <deliverDialog
        v-if="deliverDialog"
        v-on:handleClose = 'deliverDialog = false'>
        </deliverDialog>
        <!--物流码明细-->
        <instockDetailDialog
                v-if="instockDetailDialogVisable"
                v-bind:detailData="stock_in_sn"
                v-on:handleClose = 'instockDetailDialogVisable = false'>
        </instockDetailDialog>


    </div>

</template>

<script>
    // import deliverDialog from './deliverDialog';
    // import instockDetailDialog from './instockDetail'
    export default {
        name: "next_leve",
        data() {
            return {
                loading:false,
                deliverDialog:false,
                form: {
                region_city:"",
                   region_province:"",
                   region_city:"",
                   region_country:"",
                   store_img:[]
                },
                storeList:[],
                tableData: [
                ],
                instockDetailDialogVisable:false,
                stock_in_sn:'',//查看明细传递的入库单号
               //分页
                pageNo: 1,
                pageSize: 20,
                totalSize: 0,
                dealerLevel:[]//经销商级别,
                , form1: {
                    from_sn: '',
                    dealer_name: '',
                    from_level_id: '',
                }
                ,countrys:[]
                ,provinces:[]
                ,citys:[]
                ,areas:[]
            }
        },
        methods:
            {   
                // 获取四级联动
                getcountry(){
                     this.$get('logistics_2','/vstore/dealer_pc/regionlist',{
                         type:1,
                         parent_id:""
                     }).then(res=>{
                        this.countrys=res.data
                           this.citys=[]
                        this.areas=[]
                        this.provinces=[]
                        }).catch(error=>{
                        })
                } ,
                getprovinces(){
                        this.citys=[]
                        this.provinces=[]
                        this.areas=[]
                        this.form.region_province=''
                        this.form.region_city=''
                        this.form.region_area=''
                        this.$get('logistics_2','/vstore/dealer_pc/regionlist',{
                         type:2,
                         parent_id:this.form.region_country
                     }).then(res=>{
                        this.provinces=res.data
                         
                        }).catch(error=>{
                        })
                },
                getcity(){
                    this.$forceUpdate()
                      this.citys=[]
                        this.areas=[]
                        this.form.region_city=''
                        this.form.region_area=''
                      this.$get('logistics_2','/vstore/dealer_pc/regionlist',{
                         type:3,
                         parent_id:this.form.region_province
                     }).then(res=>{
                        this.citys=res.data
                        }).catch(error=>{
                        })
                },
                 getArea(){
                     this.$forceUpdate()
                       this.areas=[]
                         this.form.region_area=''
                      this.$get('logistics_2','/vstore/dealer_pc/regionlist',{
                         type:4,
                         parent_id:this.form.region_city
                     }).then(res=>{
                        this.areas=res.data
                        }).catch(error=>{
                        })
                },

                 getStoreLevel() {
                this.$get('logistics_2','/vstore/dealer_pc/dealerlevel').then(res=>{
                        this.storeList=res.data
                        }).catch(error=>{
                        })
                },
                // 所辖门店集合
                lowerStoreList(data){
                    this.$router.push({
                        name:'lowerStoreManage',
                        query:{
                            id:data.id
                        }
                    })
                },
                // 查看详情
                detail(data){
                    this.$router.push({
                        name:'lowerStoreManage',
                        query:{
                            id:data.id
                        }
                    })
                },
                edit(data){
                     this.$router.push({
                        name:'addDealer',
                        query:{
                            edit:data.id
                        }
                    })
                },
                 //选择经销商
                getDealerInfo(val) {
                    this.form1.from_sn = val.dealer_sn;
                    this.form1.dealer_name = val.dealer_name;
                },
                //请求列表数据
                onSearch(){
                    this.loading=true
                      let beginstr = '', endstr = '';
                    if (this.form.start) {
                        beginstr = this.moment(this.form.start).format("YYYY-MM-DD");
                    }
                    if (this.form.end) {
                        endstr = this.moment(this.form.end).format("YYYY-MM-DD");
                    }
                    this.$get('logistics_2','/vstore/dealer_pc/dealerlist', {
                        lang:'',
                        ...this.form,
                        per_page:this.pageSize,
                        page:this.pageNo,
                        start_time:beginstr,
                        end_time:endstr
                    }).then(res => {
                         this.loading=false
                        this.tableData = res.data.data;
                        this.totalSize = res.data.total;
                    }).catch(function (error) {
                        console.log(error);
                         this.loading=false

                    });
                },
                /*分页*/
                handleSizeChange(val) {
                    this.pageSize = val;
                    this.pageNo = 1;
                    this.onSearch();
                },
                handleCurrentChange(val) {
                    this.pageNo = val;
                    this.onSearch();
                },
                //添加入库
                add() {
                    this.$router.push({
                        name: 'addDealer'
                    });

                },
                handleSelectionChange(val) {
                    this.multipleSelection = val;
                },
                //发货
                deliver(row){
                this.deliverDialog = true;
                },
                //删除
                disables(row,temp) {
                    if(temp==2){
                        this.$confirm('是否禁用该经销商?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                      
                          var  url = '/vstore/dealer_pc/setdealerstatus' 
                        this.$get('logistics_2',url, {
                            id:row.id,
                            status:temp
                        }).then(res => {
                            if(res.code==1){
                                 this.$message({
                                type: 'success',
                                message: '禁用成功!'
                            });
                                this.onSearch()
                            }
                           
                         
                        }).catch(function (error) {
                            console.log(error);
                        });

                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消禁用'
                        });
                    });
                    }else if(temp==3){

                    
                        this.$confirm('是否删除该经销商?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        var  url = '/vstore/dealer_pc/setdealerstatus' 
                        this.$get('logistics_2',url, {
                            id:row.id,
                            status:temp
                        }).then(res => {
                            if(res.code==1){
                                 this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                                this.onSearch()
                            }
                      
                         
                        }).catch(function (error) {
                            console.log(error);
                        });

                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消删除'
                        });
                    });
                    }else{
                            
                        this.$confirm('是否启用该经销商?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        var  url = '/vstore/dealer_pc/setdealerstatus' 
                        this.$get('logistics_2',url, {
                            id:row.id,
                            status:temp
                        }).then(res => {
                            if(res.code==1){
                                 this.$message({
                                type: 'success',
                                message: '启用成功!'
                            });
                                this.onSearch()
                            }
                      
                         
                        }).catch(function (error) {
                            console.log(error);
                        });

                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消启用'
                        });
                    });
                    }
                    

                }

            },
        created() {
            this.onSearch();
            this.getStoreLevel()
            this.getcountry()
        },
        components:{
            // deliverDialog,instockDetailDialog
        }
    }
</script>
<style lang="scss" scoped>


</style>